import type { VideoStaticContent } from '@core-api/editor/types/response';
import type { Question } from '../../legacy-series-types';
import { questionLayoutToSlideLayout } from '../converters/question/question-layout-to-slide-layout';
import { questionTextLayoutToSlideTextLayout } from '../converters/question/question-text-layout-to-slide-text-layout';
import { questionToSlideImageReference } from '../converters/question/question-to-slide-image-reference';

export const getVideoStaticContent = (question: Question) => {
  const [slideLayout] = questionLayoutToSlideLayout(question.layout);

  const slideTextLayout = questionTextLayoutToSlideTextLayout(question.layout);

  const content: VideoStaticContent = {
    type: 'video',
    caption: question.question,
    label: question.title_meta,
    url: question.question_video_embed_url ?? '',
    image: {
      ...questionToSlideImageReference(question),
    },
    textAlignment: {
      textHorizontalAlign: slideTextLayout.textHorizontalAlign,
      textVerticalAlign: slideTextLayout.textVerticalAlign,
    },
    textSizeOffset: slideTextLayout.textSizeOffset,
    // TODO: what is text in the old model?
    text: question.question,
    layout: slideLayout,
    styledTitle: {},
  };

  return content;
};
